import React, { useRef, useState, useEffect } from "react";
import { VStack, HStack, Text, Box, Pressable, Button } from "native-base";
import AVCancel from "../../../components/common/AVCancel";
import EmojiPicker from "emoji-picker-react";
import FilePicker from "../../../Platform/FilePicker";
import { AVButtonRoundedFull } from "../../../components/common/AVButtons";
import VoiceMessage from "../../../components/common/VoiceMessage";
import ExternalLink from "../../../components/common/ExternalLink";
import { Loc } from "../../../App/Loc";
import {
  PaperPlaneIcon,
  MoreHorizontalIcon,
} from "../../../assets/icons/icon-assets";
import AVInputtext from "../../../components/AVInputtext";
import { CloseIcon, AddIcon } from "native-base";
import ChatInput from "../chatInput/ChatInput";

const ChatFooterEmoji = ({
  replyValue,
  isHuddleChatTab,
  images,
  showConvoFilePicker,
  isMobile,
  setreplyValue,
  ReplyLoadMedia,
  isGroupChat,
  isNewChat,
  dimensions,
  showManageConvoPopup,
  typingUserName,
  isOpenBox,
  itemEdit,
  showEmoji,
  emojiHeight,
  menuRef,
  addPhotoIconRef,
  onEmojiClick,
  toFK,
  subject,
  isLoading,
  handleSave,
  setIsHide,
  setIsGroupChat,
  setIsOpenConvo,
  setMdlConvoVisible,
  setIsOpenBox,
  setIsYouTube,
  setIsOpenCemera,
  setCameraMode,
  imageInputRef,
  menuRefs,
  handleOpenPicker,
  setExternalLink,
  HandleAddOneDrive,
  setShowExternalLinkInput,
  showExternalLinkInput,
  HandleAddDropBoxLink,
  setIsOneDriveData,
  Loading,
  isOpenConvo,
  handleSendConvoMessage,
  handleUpdatePost,
  handleSendMessage,
  convo,
  media,
  value,
  handleVoiceRecordingComplete,
  isRecording,
  setIsRecording,
  showFilePicker,
  setValue,
  setItemEdit,
  setMedia,
  setImages,
  setDeletedImages,
  setvideos,
  setUpdateConvoImage,
  setUpdateConvoVideo,
  setEditingImage,
  setShowConvoFilePicker,
  RenderImages,
  setIsdelete,
  isImageProcessing,
  editingImage,
  mdlConvoVisible,
  handleImages,
  handleChatMessage,
  debouncedHandleChatMessage,
  handleMessage,
  isSetText,
  waveformBars,
  recordingTime,
  setShowEmoji,
  shrink,
  handleKeyPress,
  inputRef,
  setRteValue,
  useRichText,
  setUseRichText,
  entityData,
}) => {
  return (
    <>
      {!useRichText && replyValue && (
        <>
          <VStack
            backgroundColor={"gray.100"}
            borderRadius={"8px"}
            width={"94%"}
            overflowY={"auto"}
            position={"absolute"}
            padding={"10px"}
            shadow={"0px 4px 12px rgba(0, 0, 0, 0.1)"}
            height={"65%"}
            top={
              isHuddleChatTab &&
              (!replyValue?.media || replyValue?.media?.id?.length === 0) &&
              (!replyValue?.galleryPost ||
                replyValue?.galleryPost?.length === 0)
                ? replyValue?.ptype === "H"
                  ? replyValue?.text?.length > 500
                    ? "calc(100vh - 540px)"
                    : "calc(100vh - 460px)"
                  : "calc(100vh - 430px)" // HuddleChat - reply text only
                : isHuddleChatTab &&
                    (replyValue?.media || replyValue?.media?.id?.length > 0) &&
                    replyValue?.text?.length > 0 &&
                    !replyValue?.media?.type?.startsWith("audio")
                  ? replyValue?.ptype === "H"
                    ? "calc(100vh - 540px)"
                    : "calc(100vh - 512px)" // HuddleChat - reply single image/video with text
                  : isHuddleChatTab &&
                      (replyValue?.media ||
                        replyValue?.media?.id?.length > 0) &&
                      replyValue?.text?.length === 0 &&
                      !replyValue?.media?.type?.startsWith("audio")
                    ? replyValue?.ptype === "H"
                      ? "calc(100vh - 540px)"
                      : "calc(100vh - 485px)" // HuddleChat - reply single image/video without text
                    : isHuddleChatTab &&
                        (replyValue?.media ||
                          replyValue?.media?.id?.length > 0) &&
                        replyValue?.media?.type?.startsWith("audio")
                      ? replyValue?.ptype === "H"
                        ? "calc(100vh - 540px)"
                        : "calc(100vh - 450px)" // HuddleChat - reply single audio
                      : isHuddleChatTab &&
                          (replyValue?.galleryPost ||
                            replyValue?.galleryPost?.length > 0) &&
                          replyValue?.text?.length > 0
                        ? replyValue?.ptype === "H"
                          ? "calc(100vh - 540px)"
                          : "calc(100vh - 512px)" // HuddleChat - reply for galleryPost with text
                        : isHuddleChatTab &&
                            (replyValue?.galleryPost ||
                              replyValue?.galleryPost?.length > 0) &&
                            replyValue?.text?.length === 0
                          ? replyValue?.ptype === "H"
                            ? "calc(100vh - 540px)"
                            : "calc(100vh - 485px)" // HuddleChat - reply for galleryPost without text
                          : !isHuddleChatTab &&
                              (!replyValue?.media ||
                                replyValue?.media?.id?.length === 0) &&
                              (!replyValue?.galleryPost ||
                                replyValue?.galleryPost?.length === 0)
                            ? replyValue?.ptype === "H"
                              ? replyValue?.text?.length > 500
                                ? "calc(100vh - 618px)"
                                : "calc(100vh - 320px)"
                              : "calc(100vh - 276px)" // reply text only
                            : !isHuddleChatTab &&
                                (replyValue?.media ||
                                  replyValue?.media?.id?.length > 0) &&
                                replyValue?.text?.length > 0 &&
                                !replyValue?.media?.type?.startsWith("audio")
                              ? replyValue?.ptype === "H"
                                ? "calc(100vh - 450px)"
                                : "calc(100vh - 370px)" // reply single image/video with text
                              : !isHuddleChatTab &&
                                  (replyValue?.media ||
                                    replyValue?.media?.id?.length > 0) &&
                                  replyValue?.text?.length === 0 &&
                                  !replyValue?.media?.type?.startsWith("audio")
                                ? replyValue?.ptype === "H"
                                  ? "calc(100vh - 450px)"
                                  : "calc(100vh - 335px)" // reply single image/video without text
                                : !isHuddleChatTab &&
                                    (replyValue?.media ||
                                      replyValue?.media?.id?.length > 0) &&
                                    replyValue?.media?.type?.startsWith("audio")
                                  ? replyValue?.ptype === "H"
                                    ? "calc(100vh - 450px)"
                                    : "calc(100vh - 300px)" // reply single audio
                                  : !isHuddleChatTab &&
                                      (replyValue?.galleryPost ||
                                        replyValue?.galleryPost?.length > 0) &&
                                      replyValue?.text?.length > 0
                                    ? replyValue?.ptype === "H"
                                      ? "calc(100vh - 450px)"
                                      : "calc(100vh - 370px)" // reply for galleryPost with text
                                    : !isHuddleChatTab &&
                                        (replyValue?.galleryPost ||
                                          replyValue?.galleryPost?.length >
                                            0) &&
                                        replyValue?.text?.length === 0
                                      ? replyValue?.ptype === "H"
                                        ? "calc(100vh - 450px)"
                                        : "calc(100vh - 335px)" // reply for galleryPost without text
                                      : ""
            }
          >
            <VStack
              width={"100%"}
              padding={"10px"}
              backgroundColor={"white"}
              borderRadius={"6px"}
              height={"auto"}
            >
              <HStack
                alignItems={"center"}
                justifyContent={"space-between"}
                width={"100%"}
              >
                <Text fontSize={"16px"} fontWeight={700}>
                  {replyValue?.person?.title}
                </Text>
                <AVCancel
                  callback={setreplyValue}
                  color={undefined}
                  size={undefined}
                />
              </HStack>

              {replyValue?.ptype === "H" ? (
                <div
                  className="htmlPost"
                  title="post"
                  dangerouslySetInnerHTML={{ __html: replyValue?.text }}
                ></div>
              ) : (
                <Text
                  fontSize={"16px"}
                  fontWeight={400}
                  numberOfLines={0}
                  maxHeight={"80%"}
                  overflowY="auto"
                >
                  {replyValue?.text}
                </Text>
              )}

              <ReplyLoadMedia item={replyValue} />
            </VStack>
          </VStack>
        </>
      )}

      {!useRichText && (!isGroupChat || isNewChat) && (
        <Box
          position={isHuddleChatTab ? "absolute" : "fixed"}
          right={isHuddleChatTab ? 0 : [!isMobile ? `${460 - 1}px` : 0]}
          width={
            isHuddleChatTab
              ? "99%"
              : isMobile
                ? "99%"
                : dimensions.width < 800
                  ? "350px"
                  : "460px"
          }
          borderColor={"AVColor.grey"}
          borderWidth={isHuddleChatTab ? 0 : 1}
          borderTopWidth={0}
          bottom={0}
          left={isMobile ? 0 : ""}
          backgroundColor={"white"}
          py={2}
          zIndex={showManageConvoPopup ? -1 : 0}
        >
          <VStack width="100%" space={2}>
            {typingUserName != "" && (
              <HStack px={3} mb={1}>
                <Text fontSize="sm" color="gray.400">
                  {typingUserName}
                </Text>
              </HStack>
            )}

            {!useRichText && showConvoFilePicker && !isOpenBox && (
              <Box px={3} mb={2}>
                <Box
                  alignItems="center"
                  justifyContent="center"
                  maxHeight={170}
                  height="auto"
                  borderWidth={1}
                  rounded="sm"
                  borderStyle="dashed"
                  bg="white"
                  width="100%"
                  p={3}
                >
                  {!useRichText && itemEdit?.id?.length > 0 && (
                    <HStack left={"48%"}>
                      <AVCancel
                        callback={() => {
                          setValue("");
                          setItemEdit("");
                          setMedia([]);
                          setImages([]);
                          setvideos([]);
                          setUpdateConvoImage([]);
                          setUpdateConvoVideo([]);
                          setEditingImage(false);
                          setShowConvoFilePicker(false);
                        }}
                        color={undefined}
                        size={undefined}
                      />
                    </HStack>
                  )}

                  {!useRichText && images && images.length > 0 && (
                    <RenderImages
                      images={images}
                      setImages={setImages}
                      setDeletedImages={setDeletedImages}
                      media={media}
                      setIsdelete={setIsdelete}
                      setMedia={setMedia}
                      isImageProcessing={isImageProcessing}
                      editingImage={editingImage}
                      setUpdateConvoImage={setUpdateConvoImage}
                      setUpdateConvoVideo={setUpdateConvoVideo}
                      setEditingImage={setEditingImage}
                      itemEdit={itemEdit}
                      setItemEdit={setItemEdit}
                      setShowConvoFilePicker={setShowConvoFilePicker}
                    />
                  )}
                </Box>
              </Box>
            )}

            {/*Input box*/}
            <ChatInput
              menuRef={menuRef}
              imageInputRef={imageInputRef}
              addPhotoIconRef={addPhotoIconRef}
              handleImages={handleImages}
              setIsOpenBox={setIsOpenBox}
              isOpenBox={isOpenBox}
              mdlConvoVisible={mdlConvoVisible}
              handleChatMessage={handleChatMessage}
              value={value}
              debouncedHandleChatMessage={debouncedHandleChatMessage}
              handleMessage={handleMessage}
              isSetText={isSetText}
              showEmoji={showEmoji}
              inputRef={inputRef}
              editingImage={editingImage}
              isLoading={isLoading}
              Loading={Loading}
              isOpenConvo={isOpenConvo}
              handleSendConvoMessage={handleSendConvoMessage}
              isGroupChat={isGroupChat}
              convo={convo}
              isHuddleChatTab={isHuddleChatTab}
              handleUpdatePost={handleUpdatePost}
              itemEdit={itemEdit}
              handleSendMessage={handleSendMessage}
              toFK={toFK}
              media={media}
              setMedia={setMedia}
              subject={subject}
              images={images}
              setImages={setImages}
              showConvoFilePicker={showConvoFilePicker}
              showFilePicker={showFilePicker}
              setIsRecording={setIsRecording}
              isRecording={isRecording}
              handleVoiceRecordingComplete={handleVoiceRecordingComplete}
              waveformBars={waveformBars}
              recordingTime={recordingTime}
              isMobile={isMobile}
              setShowEmoji={setShowEmoji}
              shrink={shrink}
              replyValue={replyValue}
              handleKeyPress={handleKeyPress}
              setRteValue={setRteValue}
              useRichText={useRichText}
              setUseRichText={setUseRichText}
              entityData={entityData}
            />

            {!useRichText && isOpenBox && (
              <Box px={3} ref={menuRef}>
                <ExternalLink
                  setIsOpenBox={setIsOpenBox}
                  setIsYouTube={setIsYouTube}
                  setIsOpenCemera={setIsOpenCemera}
                  setCameraMode={setCameraMode}
                  imageInputRef={imageInputRef}
                  menuRefs={menuRefs}
                  handleOpenPicker={handleOpenPicker}
                  setExternalLink={setExternalLink}
                  HandleAddOneDrive={HandleAddOneDrive}
                  setShowExternalLinkInput={setShowExternalLinkInput}
                  showExternalLinkInput={showExternalLinkInput}
                  HandleAddDropBoxLink={HandleAddDropBoxLink}
                  setIsOneDriveData={setIsOneDriveData}
                />
              </Box>
            )}
          </VStack>
        </Box>
      )}

      {!useRichText && isGroupChat && !isNewChat && (
        <HStack
          position={"fixed"}
          bottom={"20px"}
          width={"22%"}
          left={isMobile ? "200px" : ""}
          justifyContent={"flex-end"}
          space={5}
        >
          <Pressable
            fontSize={"16px"}
            color={"#00A7BC"}
            alignSelf={"center"}
            onPress={() => {
              setIsHide(false);
              setIsGroupChat(false);
              setMdlConvoVisible(true);
              setIsOpenConvo(true);
            }}
          >
            {Loc.currentLang.menu.cancel}
          </Pressable>
          <AVButtonRoundedFull
            btnText={Loc.currentLang.menu.save}
            callback={handleSave}
            loading={isLoading}
            px={undefined}
            height={undefined}
            isLoadingText={undefined}
            isDisabled={
              (subject?.trim()?.length == 0 && toFK.length > 1) ||
              toFK?.length == 0
            }
            isLoading={undefined}
          />
        </HStack>
      )}

      {!useRichText && showEmoji && (
        <Box
          ref={menuRef}
          position={"absolute"}
          bottom={isHuddleChatTab ? "73px" : "120px"}
          width={"100%"}
          height={isHuddleChatTab ? emojiHeight : "33%"}
          left={[`${1 - 1}px`]}
        >
          <EmojiPicker onEmojiClick={onEmojiClick} />
        </Box>
      )}
    </>
  );
};

export default ChatFooterEmoji;
